import React, { useState } from 'react';
import UserRegistrationForm from 'components/UserRegistrationForm';
import { addRoofer } from 'lib/communication/promotionalProgram';
import { UserRegistrationInfo, AppState } from 'reducers';
import { useSelector } from 'react-redux';
import Spinner from 'components/Spinner/Spinner';
import { Modal, Button } from 'react-bootstrap';
import { useDevice } from 'lib/hooks/useDevice';

const RooferRegistration = () => {
    const isFetching = useSelector((state: AppState) => state.data.promotionalProgram.props.isFetching);
    const [error, setError] = useState(false);
    const [newUser, setNewUser] = useState<UserRegistrationInfo | undefined>(undefined);
    const [show, setShow] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const { isPhone } = useDevice();

    const handleSumbit = (newUserInfo: UserRegistrationInfo) => {
        setInvalidEmail(false);
        const fetchData = async () => {
            try {
                const result = await addRoofer(newUserInfo);
                if (result) {
                    setNewUser(undefined);
                } else {
                    setNewUser(newUserInfo);
                }
                setShow(result);
            } catch (ex) {
                const e = ex as Error;
                if (e.message === 'Error: Błąd rejestracji dekarza. Podany email jest już używany.') {
                    setInvalidEmail(true);
                } else {
                    setError(true);
                }
            }
        };
        fetchData();
    };

    if (isFetching || error) {
        return <Spinner showError={error} />;
    }

    return (
        <>
            {!isPhone ? (<h2>Rejestracja dekarza</h2>) : (<></>)}
            <UserRegistrationForm userType='roofer' onSubmit={handleSumbit} userInfo={newUser} invalidEmail={invalidEmail} isRegistrationMode />
            <Modal show={show} onHide={() => { setShow(false); }}>
                <Modal.Body>{`Użytkownik zarejestrowany pomyślnie. Dane logowania zostały wysłane na podany numer telefonu.`}</Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => { setShow(false); }}>
                        Zamknij
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default RooferRegistration;
